import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OverlayModule } from '@angular/cdk/overlay';
import { TooltipConvertAmountComponent } from './tooltip-convert-amount.component';
import { CurrencyConverterPipe } from '../currency-converter.pipe';

@NgModule({
  imports: [
    CommonModule,
    OverlayModule
  ],
  declarations: [
    TooltipConvertAmountComponent,
    CurrencyConverterPipe
  ],
  exports: [
    TooltipConvertAmountComponent,
    CurrencyConverterPipe
  ]
})
export class TooltipConvertAmountModule { }